import React from 'react';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import contentMap from 'componentLibrary';
import {DynamicCheckboxGroup as _DynamicCheckboxGroup} from 'app-ui-componentlibrary/dist/componentLibrary/form/DynamicCheckboxGroup';

export const DynamicCheckboxGroup = (props) => (
  <_DynamicCheckboxGroup {...props} {...{contentMap}} />
);
export default connectDynamic(DynamicCheckboxGroup);
